import NativeObj from '../../public/mobile/utils/jsbridge/index'
import {compatibleNavImg, parseQueryString} from '../../public/mobile/utils/index'

import {Toast,Modal} from 'antd-mobile';
import {getAuthExpiredMessage, notifyAppLogout} from '../../public/mobile/utils/authExpired';
export const errHandle  = (err,json) =>{
    const originalMessage = (err.response && err.response.data && err.response.data.message) ||
        (err.data && err.data.message) || err.message ||
        (err.data && err.data.error && err.data.error.message)
    const message = getAuthExpiredMessage(err, originalMessage)
    Modal.alert(json['hrzzmb-000002'], message, [
        { text: json['hrzzmb-000003'], onPress: () => notifyAppLogout(err) },
    ])
}
// 单据状态样式统一设置
export const orderState = (state) => {
     const objState =  {
        "-1":{
            font:"自由",
            style: {background:"#ffffff","color":"#888","border":"1px solid #888"}
        },

         "3":{
            font:"提交",
            style: {background:"#ffffff","color":"#888","border":"1px solid #888"}
        },
        "2":{
            font:"审批进行中",
            style: {background:"#9ecdf4","color":"#2DA0F3","border":"1px solid #2DA0F3"}
        },
        "1":{
            font:"审批通过",
            style: {background:"#ebf7f6","color":"#1FBFA7","border":"1px solid #1FBFA7"}
        },
        "0":{
            font:"审批未通过",
            style: {background:"#f6ebec","color":"#BD3646","border":"1px solid #BD3646"}
        },

     }
     return objState[state]
}
// 时间格式兼容
export const timeFormate = (state) => {
    return state.replace(/-/g,"/")
}

export const editNav = (header,leftClick = ()=> {},rightClick = ()=> {}) =>{

    let parameters={}
    let cbs={
        leftClick: leftClick
    }
    parameters={
        leftItems: [
            {
                callback: 'leftClick',
                icon: compatibleNavImg(location.origin+'/nccloud/resources/hrzz/public/mobile/static/icon/zuo.png')
            }
        ],
        centerItems: [
            {
                title: header.name,
            }
        ],
        rightItems: []
    }
    if(header.rText){
        parameters.rightItems= [
            {
                title: header.rText,
                fontSize: 2,
                callback: 'rightClick'
            }
        ]
        cbs.rightClick= rightClick
    }
    let data = {
        'function': 'configNavBar',
        'parameters': parameters
    }
    NativeObj.configNavBar(data, cbs)
    NativeObj.blockbackbutton('', () => {
        leftClick()
    });
}

export const setUrlHash = (urlParam)=>{
    let urlData = parseQueryString(location.href) || {}
    if(Object.keys(urlData).length>0){
        window.location.hash = `${window.location.hash}&${urlParam}`
    }else{
        window.location.hash = `?${urlParam}`
    }
}

// (Date)日期转字符串(2021-05-01)
export const handleDateToStr=(date)=>{
    try {
        let formatDate=date.getFullYear()+'-'+(date.getMonth()+1<10?`0${date.getMonth()+1}`:date.getMonth()+1)+'-'+(date.getDate()<10?`0${date.getDate()}`:date.getDate())
        return formatDate
    } catch (error) {
        return ""
    }

}
export const handleDateToStrspot=(date)=>{
    try {
        let formatDate=date.getFullYear()+'.'+(date.getMonth()+1<10?`0${date.getMonth()+1}`:date.getMonth()+1)+'.'+(date.getDate()<10?`0${date.getDate()}`:date.getDate())
        return formatDate
    } catch (error) {
        return ""
    }

}
// (Date)日期转字符串 (09:01)
export const handleDateToHM=(date)=>{
    try {
        let formatDate=(date.getHours()<10?`0${date.getHours()}`:date.getHours())+':'+(date.getMinutes()<10?`0${date.getMinutes()}`:date.getMinutes())
        return formatDate
    } catch (error) {
        return ''
    }

}
// (Date)日期转字符串 (09:01:01)
export const handleDateToHMcolon=(date)=>{
    try {
        let formatDate=(date.getHours()<10?`0${date.getHours()}`:date.getHours())+':'+(date.getMinutes()<10?`0${date.getMinutes()}`:date.getMinutes())+':'+(date.getSeconds()<10?`0${date.getSeconds()}`:date.getSeconds())
        return formatDate
    } catch (error) {
        return ""
    }

}
// (Date)日期转字符串 (2021-05-01) 查询指定的第一天 以及 最后一天
export const handleDateFirstAndLastDay=(date)=>{
    try {
        let nowMonth = date.getMonth(); //当前月
        let nowYear = date.getFullYear(); //当前年
        //指定月的开始时间
        let monthStartDate = new Date(nowYear, nowMonth, 1);
        //指定月的结束时间
        let monthEndDate = new Date(nowYear, nowMonth+1, 0);
        let formatStrDate=monthStartDate.getFullYear()+'-'+(monthStartDate.getMonth()+1<10?`0${monthStartDate.getMonth()+1}`:monthStartDate.getMonth()+1)+'-'+(monthStartDate.getDate()<10?`0${monthStartDate.getDate()}`:monthStartDate.getDate())
        let formatEndDate=monthEndDate.getFullYear()+'-'+(monthEndDate.getMonth()+1<10?`0${monthEndDate.getMonth()+1}`:monthEndDate.getMonth()+1)+'-'+(monthEndDate.getDate()<10?`0${monthEndDate.getDate()}`:monthEndDate.getDate())
        return {formatStrDate,formatEndDate}
    } catch (error) {
        return ''
    }
}
// 获取当月的第一天
export const handleDateFirstDay=()=>{
    let date=new Date()
    try {
        let nowMonth = date.getMonth(); //当前月
        let nowYear = date.getFullYear(); //当前年
        //指定月的开始时间
        let monthStartDate = new Date(nowYear, nowMonth, 1);
        let formatStrDate=monthStartDate.getFullYear()+'-'+(monthStartDate.getMonth()+1<10?`0${monthStartDate.getMonth()+1}`:monthStartDate.getMonth()+1)+'-'+(monthStartDate.getDate()<10?`0${monthStartDate.getDate()}`:monthStartDate.getDate())
        return formatStrDate
    } catch (error) {
        return ''
    }
}
// 获取当月的最后一天
export const handleDateLastDay=()=>{
    let date=new Date()
    try {
        let nowMonth = date.getMonth(); //当前月
        let nowYear = date.getFullYear(); //当前年
        //指定月的结束时间
        let monthEndDate = new Date(nowYear, nowMonth+1, 0);
        let formatEndDate=monthEndDate.getFullYear()+'-'+(monthEndDate.getMonth()+1<10?`0${monthEndDate.getMonth()+1}`:monthEndDate.getMonth()+1)+'-'+(monthEndDate.getDate()<10?`0${monthEndDate.getDate()}`:monthEndDate.getDate())
        return formatEndDate
    } catch (error) {
        return ''
    }
}
// 统一请假类型标识符
export const leaveType = {
    attendance: '6QBK',
    overtime: '6QJB',
    leave: '6QQJ',
    leaveoff: '6QXJ',
    trip: '6QCC',
    tripoff: '6QXC'
}
// 统一请假判断code
export const leaveCode = {
    annualLeave: 'AL', // 年假
    unpaidLeave: 'NPL', // 无薪事假
    birthLeave: '0', // 节育假
    sickLeave: 'SL', // 病假
    injuryLeave: 'IL', // 工伤假
    lieuOfOT: '10', // 调休
    maternityLeave: 'ML', // 产假
    marriageLeave: 'MARL', // 婚假
    funeralLeave: 'GSOL' // 丧假
}